module.exports = __webpack_public_path__ + "static/media/money-pounds-ten.0e3e58c5.svg";